import { API_AUTH } from "../common";
const GiaoDichTrongNgayApi = {
  getBaoCao: (params) => {
    return API_AUTH.get("api/giaodich/baocao", params);
  },

};
export default GiaoDichTrongNgayApi;